export const buildSelectedOrders = (orders, checkedOrder) => {
  return orders.reduce((selection, order) => {
    const selectedIds = checkedOrder[order.Order] || [];
    const items = order.items.filter(item => selectedIds.includes(item.PTasks_id));
    if (items.length > 0) selection.push({...order, items});
    return selection;
  }, []);
};

export const buildCompletionPayload = (selectedOrders, reportedDurations, employee) => ({
  employeeName: employee.name,
  employeeId: employee._id,
  pTasks: selectedOrders.flatMap(order => order.items.map(item => ({
    id: item.PTasks_id,
    ...(item.supportsReportedDuration && reportedDurations[item.PTasks_id] && {
      reportedDuration: reportedDurations[item.PTasks_id]
    })
  })))
});
